export default {
    setIsLogged(state, isLogged) {
        state.isLogged = isLogged;
    },
    setUser(state, user) {
        state.user = user;
        state.isLogged = true;
    },
    setDirecciones(state, dirs) {
        state.user.direcciones = dirs;
    },
    logout(state) {
        state.isLogged = false;
        state.user = null;
    },
    setLoginCaptchaActivo(state, val) {
        state.loginCaptchaActivo = val;
    },
    setFormasPago(state, f) {
        state.formasPago = f;
    },
    setLoadingFormasPago(state, b) {
        state.loadingFormasPago = b;
    },
    setSnackbarEmail(state, b) {
        state.snackbarEmail = b;
    },
    setSnackbarEmail2(state, b) {
        state.snackbarEmail2 = b;
    }
}